import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class UtilityServiceService {
  renderImage = new BehaviorSubject<any>('');
  constructor(private apiService: ApiService) { }

  getBankAddressByIfsc(ifscCode) {
    const URL = `${environment.utilityService}/api/utils/bankaddress?ifsc=${ifscCode}`;
    return this.apiService.get(URL);
  }

  addUpdateBankDetails(payLoad) {
    const URL = `${environment.userServiceUrl}/api/user/v1/get/trainingpartner/update/bank/detail/byloginRole`;
    return this.apiService.patch(URL, payLoad)
  }

  getBankDetails(shemeRefId) {
    const URL = `${environment.userServiceUrl}/api/user/v1/trainingpartner/bankdetail/from/scheme?schemeReferenceId=${shemeRefId}`;
    return this.apiService.get(URL)
  }

  getCountryCode() {
    const URL = `${environment.utilityService}/api/utils/countrycode`;
    return this.apiService.get(URL);
  }

  dumyAdhaarValidation(adhaarNumber) {
    const url = `${environment.utilityService}/api/utils/adhaar?AadharNumber=${adhaarNumber}`;
    return this.apiService.get(url)
  }

  getEmployeeStatusList() {
    const URL = `${environment.utilityService}/api/utils/dropdown/employeestatus`;
    return this.apiService.get(URL);
  }

  isDummyAadhaarRequired() {
    const URL = `${environment.utilityService}/api/utils/controls/dummyaadhaar/required`;
    return this.apiService.get(URL);
  }

  getBankName(query) {
    const URL = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/Bank/${query}`;
    return this.apiService.get(URL)

  }

  getPfmsMessagesByCandidateId(canId) {
    const URL = `${environment.userServiceUrl}/v1/candidates/get/pfms/candidate?candidateId=${canId}`;
    return this.apiService.get(URL)
  }
  generateBenegiciaryId(canId) {
    const URL = `${environment.userServiceUrl}/v1/candidates/get/generatPFMSBenefaceray?candidateId=${canId}`;
    return this.apiService.get(URL)
  }

  checkExisitingAadhar(aadarRefKey) {
    const URL = `${environment.userServiceUrl}/v1/candidates/get/canidate/check/aadhar/exist?candidateRefrenceId=${aadarRefKey}`;
    return this.apiService.get(URL);

  }

  getCurrentDate() {
    const url = `${environment.smartServiceURL}/api/smart/v1/currentDate`;
    return this.apiService.get(url);
  }

  createCandidate(data) {
    const url = `${environment.userServiceUrl}/api/user/v1/register/Candidate/phoneotp/999999`;
    return this.apiService.post(url, data);
  }

  getPayLoad(userName, role, source, state, district, idType, altType) {
    const URL = `${environment.utilityService}/api/utils/dummyCandidate?userName=${userName}&role=${role}&source=${source}&state=${state}&district=${district}&idType=${idType}&altType=${altType}`;
    return this.apiService.get(URL);
  }

  getPmkvyConfig() {
    const URL = `${environment.utilityService}/api/utils/pmkvyutility/activeScheme`;
    return this.apiService.get(URL);
  }

  getUtilityConfig() {
    const URL = `${environment.utilityService}/api/utils/utilityconfig`;
    return this.apiService.get(URL);
  }

  dummyAadharVerifyVersoionTwo(rawAadhar) {
    const URL = `${environment.utilityService}/api/utils/dummyAadhar/${rawAadhar}`;
    return this.apiService.get(URL);
  }
  getActiveScheme() {
    const URL = `${environment.utilityService}/api/utils/controls/activeScheme`;
    return this.apiService.get(URL);
  }

  disablePmkvyControl() {
    const URL = `${environment.utilityService}/api/utils/controls/disabplePmkvy`;
    return this.apiService.get(URL);
  }

  getMasterQuestion(type) {
    const URL = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/feedback?type=${type}`;
    return this.apiService.get(URL);
  }

  addFeedback(body) {
    const URL = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/feedback/create`;
    return this.apiService.post(URL, body);
  }

  updateFeedback(batchId, createdBy, type, body) {
    const URL = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/feedback/update?batchId=${batchId}&createdBy=${createdBy}&type=${type}`;
    return this.apiService.patch(URL, body);
  }

  getFeedbackData(batchId, createdBy, type) {
    const URL = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/feedback/getfeedback?batchId=${batchId}&createdBy=${createdBy}&type=${type}`;
    return this.apiService.get(URL);
  }
  getTpFeedBack(createdBy) {
    const URL = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/feedback/getfeedback?&createdBy=${createdBy}`;
    return this.apiService.get(URL);
  }
  getFeedbackHistoryById(id) {
    const URL = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/feedback/historybyid?id=${id}`;
    return this.apiService.get(URL);
  }
  getFeedbackHistory(batchId, createdBy) {
    const URL = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/feedback/history?d.batchId=${batchId}&d.createdBy=${createdBy}`
    return this.apiService.get(URL);
  }

  getTcDetails(tcId, toProject) {
    const projectionString = toProject.toString()
    const URL = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/tcdetails?userName=${tcId}&projection=${projectionString}`
    return this.apiService.get(URL)
  }

  isEnrollmentCompleted(batchId, createdBy) {
    const URL = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/isEnrollmentCompleted?batchId=${batchId}&createdBy=${createdBy}&type=CEG`;
    return this.apiService.get(URL);
  }

  // Homepage apis
  getTpByStateAndDistrict(state, district, pageno, items) {
    const URL = `${environment.utilityService}/api/utils/homepage/gettpdetails?state=${state}&district=${district}&pageNo=${pageno}&itemsPerPage=${items}`;
    return this.apiService.get(URL);
  }
  getTpByTpId(tpId) {
    const URL = `${environment.utilityService}/api/utils/homepage/gettpdetails?tpId=${tpId}`;
    return this.apiService.get(URL);
  }
  getTcByStateAndDistrict(state, district, pageno, items) {
    const URL = `${environment.utilityService}/api/utils/homepage/gettcdetails?state=${state}&district=${district}&pageNo=${pageno}&itemsPerPage=${items}`;
    return this.apiService.get(URL);
  }
  getTcByTcId(tcId) {
    const URL = `${environment.utilityService}/api/utils/homepage/gettcdetails?tcId=${tcId}`;
    return this.apiService.get(URL);
  }
  // getCandidateDetails(pageno, limit) {
  //   const URL = `${environment.utilityService}/api/utils/homepage/getcandidatesdetails?pageNo=${pageno}&itemsPerPage=${limit}`;
  //   return this.apiService.get(URL);
  // }
  getCandidateDetailsByCandidateId(id) {
    const URL = `${environment.utilityService}/api/utils/homepage/getcandidatesdetails?candidateId=${id}`;
    return this.apiService.get(URL);
  }
  getCandidateDetailsBySearchFields(tt, scheme, subscheme, tpId, tcId, pageNo, limit) {
    const URL = `${environment.utilityService}/api/utils/homepage/getcandidatesdetails?trainingType=${tt}&scheme=${scheme}&subScheme=${subscheme}&tpId=${tpId}&tcId=${tcId}&pageNo=${pageNo}&itemsPerPage=${limit}`;
    return this.apiService.get(URL);
  }

  getSchemeWisePerformanceByTpAndScheme(tpId, scheme) {
    const URL = `${environment.utilityService}/api/utils/homepage/getschemewiseperformance?tpId=${tpId}&scheme=${scheme}`;
    return this.apiService.get(URL);
  }
}
